export default "__VITE_ASSET__GUtNOaS5__"